import Start from '../../views/StartView';
import Scene from '../../views/SceneView';
import Summary from '../../views/SummaryView';
import constants from '../constants';
import { ViewsObject } from './viewsTypes';
import initStartView from '../../views/StartView/init';
import initSceneView from '../../views/SceneView/init';
import initSummary from '../../views/SummaryView/init';

const { START, SCENE, SUMMARY } = constants.VIEW_NAMES;

export const views = [
  {
    name: START,
    component: Start,
    init: initStartView,
  },
  {
    name: SCENE,
    component: Scene,
    init: initSceneView,
  },
  {
    name: SUMMARY,
    component: Summary,
    init: initSummary,
  },
];

const viewsObject: ViewsObject = views.reduce(
  (acc, curr, index, arr) => ({
    ...acc,
    [curr.name]: {
      ...curr,
      prevView: index > 0 ? arr[index - 1].name : false,
      nextView: index + 1 !== arr.length ? arr[index + 1].name : false,
    },
  }),
  {}
);

export default viewsObject;
